import React, {Component} from "react";
import axios from "axios";
import { CategoryData } from "../components/CategoryData";
import { ArticleData } from "../components/ArticleData";
import PageNav from "../partials/PageNav";

class SearchItem extends Component{

    state = {
        items : [],
        categories : [],
    }

    async getSearchItems (){
        let items = await axios.get(`items/search/${ this.props.match.params.search }`)
        if(items.status == 200){
            this.setState({ items : items.data })
        }
    }

    async getCategories (){
        let categories = await axios.get('categories')
        if(categories.status == 200){
            this.setState({ categories : categories.data })
        }
    }

    componentDidMount(){
        this.getSearchItems()
        this.getCategories()
        this.refreshToken()
        window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
    }

    async refreshToken () {
        try{
          var token = await axios.get('token');
          if(token.status === 200)
          {
              var user = (token.data.data);
              localStorage.setItem("user", JSON.stringify(user));
          }
          else if(token.status === 401)
          {
            axios.delete('logout').then((re) => { console.log("disconnect") }).catch((erro) => { console.log("error") });
            window.localStorage.clear();
          }
        }catch(error) {
            axios.delete('logout').then((re) => { console.log("disconnect") }).catch((erro) => { console.log("error") });
            window.localStorage.clear();
        }
    }

    render(){
        var category = null, articles = [];
        this.state.items.map((item) => {
            articles.push(item)
        })
        let pageNav = PageNav( "🍭Recherche " + this.props.match.params.search ,  "/items/search/" + this.props.match.params.search,  "/logo192.png",  this.props.match.params.search,  "Resultat de recherche " + this.props.match.params.search );
        
        return(
            <main id="main">
            { pageNav}
                    
                <section id="blog" className="blog">
                    <div className="container p-0" data-aos="fade-up">

                        <div className="row">
                            <div className="col-md-9">
                                <div className="posts-list row">
                                {
                                    articles.length > 0 && (<ArticleData search={ this.props.match.params.search } articles={ articles } /> )
                                }
                                </div>
                            </div>
                            <div className="col-md-3">
                                <CategoryData categories={ this.state.categories } articles={ articles ? articles.sort((a, b) => a.createdAt < b.createdAt ? 1 : -1 ).filter( data => data.comment != 3).slice(0, 5) : [] } />
                            </div>
                        </div>
                    </div>
                </section>
            </main> 
        )
    }
}
export default SearchItem;